<template>
  <div class="body_container">
    <Contact></Contact>
    <div class="width_margin">
      <div class="container_content_list_title">글로벌 역량 진단</div>
    </div>

    <div class="width_margin">
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication34.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">
                #간편/신뢰/효과
              </div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              외국어 능력평가 : SPAC^
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            핵심인재 국제 감각 양성, 신뢰도 높은 산업별 데이터로 교육 전후
            효과성 분석에 탁월한 최적의 어학 평가 솔루션입니다.
          </div>
          <div class="container_content_text_content">
            정확한 스피킹 실력평가가 가능한 기업/단체 전용 시험으로 교육대상자
            선정 및 성과 측정, 신입사원선발, 해외주재원 선발 등에 적합<br />
            15분간 평가 시간이 소요되며, 언제, 어디서나 모바일로 응시 가능한
            편리성 보유<br />
            250,000여건 기업/산업별 데이터 분석자료 제공, 전문 rater의 영역별
            평가 및 종합 첨삭 코멘트 제공
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication35.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">
                #성공한 인재 역량
              </div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              글로벌역량진단 : gCAT
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            자사의 글로벌 역량을 선별하고 훈련 프로그램 구성의 기준을 제시,
            글로벌 인재 풀(pool)의 확보 및 관리, 해외 파견 예정자 및 예비 인재,
            임직원의 글로벌 역량강화 종합 솔루션을 제공합니다.
          </div>
          <div class="container_content_text_content">
            글로벌 역량강화의 기준(Standard) 제공하여 공정한 해외파견 예정자 및
            예비 인재 풀 선발에 활용하며 훈련 프로그램 컨설팅 제공<br />
            성공하는 글로벌인재들의 역량을 기준으로 6가지 요인과 3가지 상황
            요인으로 진단하여 성공적인 업무 수행과 생활 가능성 예측 가능<br />
            해외주재원 등 현지 파견 대상자 선발 / 파견 인원에 대한 지속적 교육
            가능 / 교육 도출 목적의 자가진단(DC)과 선발 목적의 평가(AC) 버전
            제공
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication36.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#항공영어평가</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              항공 영어능력평가 : EPTA
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            항공종사자들의 영어 청취 능력과 말하기 능력을 평가하는 항공종사자
            영어 능력 전문 평가시험입니다.
          </div>
          <div class="container_content_text_content">
            국내 유일의 EPTA 모의시험으로 영어 능력 전문 평가 시험 실전 대비가
            필요한 항공종사자들에게 추천<br />
            실제 시험과 동일한 문제 구성과 문제 난이도로 실전 응시 훈련 가능<br />
            숙련된 조종사 출신의 평가자와 신속하고 정확한 평가, 다수의 실제
            데이터 결과 확보로 신뢰도 있는 모의시험 결과 도출 가능
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Global/ContactUs.vue";
export default {
  components: {Contact},
  name: "Globalcompetence",
};
</script>

<style></style>
